import { RichTextEditor } from '@mantine/tiptap';
import Placeholder from '@tiptap/extension-placeholder';
import { type Editor, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import classes from './ChatInputTextEditor.module.css';
import { ChatSuggestionList } from '#components/chat/ChatSuggestionList';
import { useMentionExtension } from '#components/chat/hooks/useMentionExtension';

export interface ChatInputTextEditorProps {
  value: string;
  onChange?: (value: Editor) => void;
  onSubmit: () => void;
}

export function ChatInputTextEditor({ value, onChange, onSubmit }: ChatInputTextEditorProps) {
  const [_mention, suggestion] = useMentionExtension({
    entries: [
      {
        externalId: '1',
        type: 'asset',
        name: 'Gas Production AB-1',
      },
      // {
      //   externalId: '2',
      //   type: 'asset',
      //   name: 'Gas Production CD-2',
      // },
      // {
      //   externalId: '3',
      //   type: 'timeSeries',
      //   name: 'Water Production D-3',
      // },
      // {
      //   externalId: '4',
      //   type: 'asset',
      //   name: 'Water Production E-4',
      // },
    ] as const,
    keys: [
      { name: 'externalId', getFn: (it) => it.externalId ?? '', weight: 3 },
      { name: 'name', getFn: (it) => it.name ?? '', weight: 2 },
    ],
  });

  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({ placeholder: 'Ask Atlas anything...' }),
      // mention
    ],
    content: value,
    onUpdate: ({ editor }) => {
      onChange?.(editor);
    },
  });

  return (
    <RichTextEditor className={classes.editor} editor={editor}>
      <RichTextEditor.Content
        onKeyDownCapture={(ev) => {
          if (!ev.shiftKey && ev.key === 'Enter') {
            ev.preventDefault();
            ev.stopPropagation();

            onSubmit?.();
            editor?.commands.clearContent();

            return false;
          }
        }}
      />
      <ChatSuggestionList
        editor={editor}
        suggestion={suggestion}
        formatEntry={(entry) => (
          <span>
            <strong>{entry.item.name}</strong> (externalId={entry.item.externalId})
          </span>
        )}
        onSelect={(entry) => {
          suggestion.command?.({ id: entry.item.externalId, label: entry.item.name });
        }}
      />
    </RichTextEditor>
  );
}
